import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Details", -1)
const _hoisted_4 = { class: "capitalize" }
const _hoisted_5 = { class: "capitalize" }
const _hoisted_6 = { class: "mt-4 border border-gray-400 rounded" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Payment Details", -1)
const _hoisted_8 = { class: "capitalize" }
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_11 = {
  key: 1,
  class: "capitalize"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "capitalize" }
const _hoisted_14 = { class: "capitalize" }
const _hoisted_15 = { class: "capitalize" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { style: {"color":"red"} }, "Discounts are already applied above", -1)
const _hoisted_24 = { class: "mt-1" }
const _hoisted_25 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_26 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-warning w-fit"
}
const _hoisted_27 = {
  key: 0,
  class: "mt-4 border border-gray-400 rounded"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Invoice Details", -1)
const _hoisted_29 = { class: "mt-6 border rounded" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400 rounded" }, "Allocations", -1)
const _hoisted_31 = { class: "w-full table-fixed" }
const _hoisted_32 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_33 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_34 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_35 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_36 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_37 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_38 = { class: "px-2 py-3 capitalize" }
const _hoisted_39 = { class: "px-2 py-2 capitalize" }
const _hoisted_40 = { class: "px-2 py-2 capitalize" }
const _hoisted_41 = { class: "px-2 py-2 capitalize" }
const _hoisted_42 = { class: "px-2 py-2 capitalize" }

import { ref } from "vue";
import { useRoute } from "vue-router";

import TitleHeader from "@/components/TitleHeader.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";

import api from "@/api/api";
import { License, Transaction } from "@/types";
import { intlFormat } from "@/utils/price";
import { useGlobalStore, useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseView',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();
const { userIsAdmin } = useUserStore();

const license_id = ref("");
const organisation_id = ref("");

const license = ref({} as License);
const transactions = ref({} as Transaction[]);

var totalGrossPrice = 0;
var totalNetPrice = 0;
var totalTax = 0;
var taxPercentage = 0;
var subscriptionsPurchased = 0;
var totalDiscount = 0;

license_id.value = route.params.lid as string;
organisation_id.value = route.params.oid as string;

async function markAsInvoiceIssued(org_id: number, id: number) {
  try {
    const response = await api.license.toggleLicenseInvoiceIssued(org_id, id);

    const issued = response.data.license.invoice_issued ? "issued" : "not issued";
    license.value = response.data.license;

    globalStore.toast("SUCCESS", `Invoice marked as ${issued}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating License`);
  }
}

async function markAsInvoiceAsPaid(org_id: number, id: number) {
  try {
    const response = await api.license.markLicenseInvoiceAsPaid(org_id, id);

    const paid = response.data.license.invoice_paid ? "paid" : "not paid";
    license.value = response.data.license;

    globalStore.toast("SUCCESS", `Invoice marked as ${paid}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

async function markAsInvoiceRefunded(org_id: number, id: number) {
  try {
    const response = await api.license.toggleInvoiceRefunded(org_id, id);

    const refunded = response.data.license.is_refunded ? "refunded" : "not refunded";
    license.value = response.data.license;

    globalStore.toast("SUCCESS", `Invoice marked as ${refunded}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

function calculateOriginalNetPrice(net_price: Number) {
  const percent_amount = transactions.value[0]!.discount ? transactions.value[0]!.discount.percent_amount : 0;

  const discountDivisor = 100 - Number(percent_amount);
  const net_priceMultiplied = Number(net_price) * 100;

  return net_priceMultiplied / discountDivisor;
}

function calculateDiscount(net_price: Number, percent_amount: Number) {
  const original_net_price = calculateOriginalNetPrice(net_price);
  return intlFormat(original_net_price * (Number(percent_amount) / 100), transactions.value[0]?.currency);
}

function calculateDiscountAsNumber(net_price: Number, percent_amount: Number) {
  const original_net_price = calculateOriginalNetPrice(net_price);
  return original_net_price * (Number(percent_amount) / 100);
}

if (!userIsAdmin) {
  window.location.href = "/error";
}

try {
  // license.value = (await api.license.getLicenseById(Number(organisation_id.value), Number(license_id.value))).data.license;
  const data = ((
  ([__temp,__restore] = _withAsyncContext(() => api.license.getLicenseWithTransactionsById(Number(organisation_id.value), Number(license_id.value)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data;
  console.log("data", data);
  license.value = data.license;
  transactions.value = data.transaction_group;
  totalGrossPrice = data.TotalGrossPrice;
  totalNetPrice = data.TotalNetPrice;
  totalTax = data.TotalTax;
  taxPercentage = data.TaxPercentage;
  subscriptionsPurchased = data.SubscriptionsPurchased;
  totalDiscount = data.TotalDiscount;

  if (!transactions.value[0].group_subscriptions_quantity) {
    subscriptionsPurchased = transactions.value[0].quantity;
  }

  const discount = calculateDiscountAsNumber(transactions.value[0].net_price, transactions.value[0].discount!.percent_amount);

  if (transactions.value[0].payment_gateway === "Stripe" && discount > 0) {
    totalNetPrice = totalNetPrice + calculateDiscountAsNumber(transactions.value[0].net_price, transactions.value[0].discount!.percent_amount);
  }
} catch (error) {
  console.log("error", error);
  // window.location.href = "/error";
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('license-details'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(ListRowItem, {
          title: _ctx.$t('user')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `/dashboard/users/${license.value.user_id}`,
              class: "capitalize text-blue"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(license.value.user.first_name) + " " + _toDisplayString(license.value.user.last_name), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('organisation')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(license.value.organisation.name), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        (license.value.affiliate_id)
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 0,
              title: _ctx.$t('affiliate_id')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(license.value.affiliate_id), 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(ListRowItem, {
          title: _ctx.$t('order-date')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(new Date(license.value.created_at).toLocaleString()), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('event')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `/dashboard/courses/events/${license.value.event_id}`,
              class: "capitalize text-blue"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(license.value.event.name) + " (#" + _toDisplayString(license.value.event.id) + ")", 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('level')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(license.value.level), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('places')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(license.value.amount) + " (" + _toDisplayString(license.value.allocations.length) + " used)", 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('subscriptions_purchased')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_unref(subscriptionsPurchased)), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(ListRowItem, {
          title: _ctx.$t('transaction-id')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_8, _toDisplayString(license.value.transaction_id), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('payment-type')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_9, _toDisplayString(license.value.payment_method), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('address')
        }, {
          default: _withCtx(() => [
            (license.value.address_line_one)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(license.value.address_line_one) + ", " + _toDisplayString(license.value.address_line_two) + ", " + _toDisplayString(license.value.city) + ", " + _toDisplayString(license.value.postcode) + ", " + _toDisplayString(license.value.country), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(license.value.organisation.address_line_one) + ", " + _toDisplayString(license.value.organisation.address_line_two) + ", " + _toDisplayString(license.value.organisation.city) + ", " + _toDisplayString(license.value.organisation.postcode) + ", " + _toDisplayString(license.value.organisation.country), 1))
          ]),
          _: 1
        }, 8, ["title"]),
        (license.value.payment_method === 'Credit/Debit Card' || license.value.payment_method === 'online')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(ListRowItem, {
                title: _ctx.$t('payment-gateway-customer-id')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(license.value.user.stripe_customer_id), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('payment-gateway-order-id')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(transactions.value[0]!.order_id), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(ListRowItem, {
          title: _ctx.$t('funds-recieved')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_15, _toDisplayString(license.value.funds_received_at ? new Date(license.value.funds_received_at).toLocaleString() : "Not Received"), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        (transactions.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (transactions.value[0].discount)
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 0,
                    title: _ctx.$t('discount_code')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(transactions.value[0].discount.code), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(ListRowItem, {
                title: _ctx.$t('net-price')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_unref(intlFormat)(_unref(totalNetPrice), transactions.value[0].currency)), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              (transactions.value[0].payment_gateway !== '2Checkout' && transactions.value[0].payment_gateway !== 'Invoice')
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 1,
                    title: _ctx.$t('discount')
                  }, {
                    default: _withCtx(() => [
                      (transactions.value[0].discount)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, " - " + _toDisplayString(calculateDiscount(transactions.value[0].net_price, transactions.value[0].discount!.percent_amount)) + " (" + _toDisplayString(transactions.value[0].discount?.percent_amount) + "%) ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_18, "0.00"))
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (transactions.value[0].payment_gateway === 'Invoice' && transactions.value[0].pricing_rrp)
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 2,
                    title: _ctx.$t('discount')
                  }, {
                    default: _withCtx(() => [
                      (transactions.value[0].discount)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, " - " + _toDisplayString(_unref(intlFormat)(_unref(totalDiscount), transactions.value[0].currency)) + " (" + _toDisplayString(transactions.value[0].discount?.percent_amount) + "%) ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_20, "0.00"))
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(ListRowItem, {
                title: _ctx.$t('tax')
              }, {
                default: _withCtx(() => [
                  (Number(transactions.value[0].vat) !== -1.0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_unref(intlFormat)(_unref(totalTax), transactions.value[0].currency)) + " (" + _toDisplayString(_unref(taxPercentage)) + "%)", 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_22, "UNKNOWN/TBC"))
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('total')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_unref(intlFormat)(_unref(totalGrossPrice), transactions.value[0].currency)), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              (transactions.value[0].discount && ['2Checkout'].includes(transactions.value[0].payment_gateway))
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 3,
                    title: _ctx.$t('discounted_product_code')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(transactions.value[0].discount.verifone_product_code) + " (", 1),
                        _hoisted_23,
                        _createTextVNode(")")
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(ListRowItem, {
          title: _ctx.$t('status')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              (license.value.payment_status === 'complete')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Confirmed"))
                : _createCommentVNode("", true),
              (license.value.payment_status === 'pending')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Pending"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('refunded?')
        }, {
          default: _withCtx(() => [
            _createVNode(ToggleCheckbox, {
              value: license.value.is_refunded,
              onToggle: _cache[0] || (_cache[0] = ($event: any) => (markAsInvoiceRefunded(license.value.organisation_id, license.value.id)))
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      (license.value.payment_method === 'Invoice')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(ListRowItem, {
              title: _ctx.$t('invoice-issued')
            }, {
              default: _withCtx(() => [
                _createVNode(ToggleCheckbox, {
                  value: license.value.invoice_issued,
                  onToggle: _cache[1] || (_cache[1] = ($event: any) => (markAsInvoiceIssued(license.value.organisation_id, license.value.id)))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _ctx.$t('invoice-paid')
            }, {
              default: _withCtx(() => [
                _createVNode(ToggleCheckbox, {
                  value: license.value.invoice_paid,
                  onToggle: _cache[2] || (_cache[2] = ($event: any) => (markAsInvoiceAsPaid(license.value.organisation_id, license.value.id)))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _ctx.$t('purchase-order-number')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(license.value.purchase_order_number), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _ctx.$t('tax-registration-number')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(license.value.invoice_tax_registration_number ? license.value.invoice_tax_registration_number : "N/A"), 1)
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("table", _hoisted_31, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_32, [
            _createElementVNode("th", _hoisted_33, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`event`)), 1)
            ]),
            _createElementVNode("th", _hoisted_34, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`attendee`)), 1)
            ]),
            _createElementVNode("th", _hoisted_35, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`booking`)), 1)
            ]),
            _createElementVNode("th", _hoisted_36, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`issued by`)), 1)
            ]),
            _createElementVNode("th", _hoisted_37, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`date`)), 1)
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(license.value.allocations, (alloc) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400 divide-x divide-gray-300",
              key: alloc.id
            }, [
              _createElementVNode("td", _hoisted_38, [
                _createVNode(_component_router_link, {
                  to: `/dashboard/courses/events/${alloc.event_id}`,
                  class: "text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(license.value.event.name) + " (#" + _toDisplayString(license.value.event.id) + ")", 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", _hoisted_39, [
                _createVNode(_component_router_link, {
                  to: `/dashboard/users/${alloc.attendee_id}`,
                  class: "text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(alloc.attendee.first_name) + " " + _toDisplayString(alloc.attendee.last_name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", _hoisted_40, [
                _createVNode(_component_router_link, {
                  to: `/dashboard/courses/events/${alloc.event_id}/bookings/${alloc.booking_id}`,
                  class: "text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(alloc.booking_id), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", _hoisted_41, [
                _createVNode(_component_router_link, {
                  to: `/dashboard/users/${alloc.user_id}`,
                  class: "text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(alloc.user.first_name) + " " + _toDisplayString(alloc.user.last_name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", _hoisted_42, _toDisplayString(new Date(alloc.created_at).toDateString()), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})